



export enum ClientEvent {
    TokenUpdated = "tokenUpdated",
    TokenAutoUpdateFailed = "tokenAutoUpdateFailed",
    TokenMaxLifetimeReached = "tokenMaxLifetimeReached",
    ClientDestroyed = "clientDestroyed",
    ConnectionStateChanged = "connectionStateChanged"
}





export type ConnectionState = "connected" | "connecting" | "disconnected" | "notInitialized";






export interface SdkConnectionState {
    overall: ConnectionState;
    network: "connected" | "disconnected";
    conversations: ConnectionState;
    voice: ConnectionState;
    taskrouter: ConnectionState;
}





export interface ClientEventsType {
    tokenUpdated: (token: string, refreshToken?: string) => void;
    tokenAutoUpdateFailed: () => void;
    tokenMaxLifetimeReached: (newTokenDateExpired: Date) => void;
    clientDestroyed: () => void;
    connectionStateChanged: (state: SdkConnectionState) => void;
    [key: string]: (...args: any[]) => void;
}





export enum ConversationClientEvent {
    ConversationAdded = "conversationAdded",
    ConversationJoined = "conversationJoined",
    ConversationLeft = "conversationLeft",
    ConversationRemoved = "conversationRemoved",
    ConversationUpdated = "conversationUpdated",
    ParticipantJoined = "participantJoined",
    ParticipantLeft = "participantLeft",
    ParticipantUpdated = "participantUpdated",
    MessageAdded = "messageAdded",
    MessageRemoved = "messageRemoved",
    MessageUpdated = "messageUpdated",
    TokenAboutToExpire = "tokenAboutToExpire",
    TokenExpired = "tokenExpired",
    TypingEnded = "typingEnded",
    TypingStarted = "typingStarted",
    PushNotification = "pushNotification",
    UserSubscribed = "userSubscribed",
    UserUnsubscribed = "userUnsubscribed",
    UserUpdated = "userUpdated",
    StateChanged = "stateChanged",
    Initialized = "initialized",
    InitFailed = "initFailed",
    ConnectionStateChanged = "connectionStateChanged",
    ConnectionError = "connectionError"
}





export enum VoiceClientEvent {
    Error = "error",
    Incoming = "incoming",
    Destroyed = "destroyed",
    TokenWillExpire = "tokenWillExpire",
    Unregistered = "unregistered"
}
